import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Popover } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
const HideValue = ({ showPopOver = false, popOverMessage, iconSize, customStyle, }) => {
    const icon = (_jsx(FontAwesomeIcon, { icon: faEyeSlash, size: iconSize, style: customStyle }));
    if (!showPopOver)
        return icon;
    return (_jsx(Popover, { placement: "topRight", content: popOverMessage || "You don't have access to view this content", title: (_jsxs("span", { children: [_jsx(FontAwesomeIcon, { icon: faCircleExclamation, style: { color: '#ff4d4f' } }), ' ', "Restricted Access"] })), children: icon }));
};
export default HideValue;
